<template>
  <v-container>
    <p>Edit cleaning supply</p>
    <v-row>
      <v-col
        cols="12"
        lg="10"
        md="12"
      >
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="supplier.name"
              label="Name"
              :rules="[rules.require]"
              outlined
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="supplier.branch"
              label="Price"
              :rules="[rules.require]"
              outlined
              dense
            />
          </v-col>
        </v-row>
        <app-cleaning-supply-list
          :cleaning_supplies="cleaning_supplies"
          :cleaning_supply_list="cleaning_supply_list"
        />
        <v-divider></v-divider>
        <div class="text-left">
          <v-btn
            class="mx-2"
            small
            color="orange"
            dark
            @click="updateSupplier"
          >
            Update
          </v-btn>
          <v-btn
            class="mx-2"
            small
            exact
            :to="{ name: 'supplier-list' }"
          >
            Cancel
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { authHeader } from '../../../_helpers';
export default {
  name: "SupplierEdit",
  components: {
    AppCleaningSupplyList: () => import('../components/cleaning-supply-list')
  },
  data: () => ({
    supplier_id: null,
    supplier: {
      name: null,
      branch: null
    },
    cleaning_supply_list: [],
    cleaning_supplies: [],
    rules: {
      require: value => !!value || 'Please fill in information',
    },
  }),
  async mounted () {
    let id = this.$route.params.id
    this.cleaning_supply_list = []
    this.getSupplier(id)
  },
  methods: {
    async getSupplier (id) {
      this.supplier_id = id
      try {
        const result = await this.$http.get(`/back-office/suppliers/${this.supplier_id}`, authHeader())
        this.supplier.name = result.data.name
        this.supplier.branch = result.data.branch
        this.cleaning_supplies = result.data.CleaningSupplies
      } catch (err) {
        console.log(err)
        alert('Something went wrong')
      }
    },
    async updateSupplier () {
      try {
        if (this.requireField()) {
          await this.$http.put(`/back-office/suppliers/${this.supplier_id}`, this.supplier, authHeader())
          let cleaning_supplies = []
          for (let cleaning_supply of this.cleaning_supply_list) {
            if (cleaning_supply.selected)
              cleaning_supplies.push(cleaning_supply.id)
          }
          await this.$http.put(`/back-office/suppliers/${this.supplier_id}/cleaning-supplies`, { cleaning_supplies }, authHeader())
          this.$router.push({ name: 'supplier-list'})
        }
      } catch (err) {
        console.log(err)
        alert('Something went wrong')
      }
    },
    requireField () {
      if (!this.supplier.name) {
        alert('Please fill in supplier name')
        return false
      }
      if (!this.supplier.branch) {
        alert('Please fill in supplier branch')
        return false
      }
      return true
    },
  },
};
</script>
